import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@ddt-web/common';
import { AnimationsModule } from '@ddt-web/dom';
import { GenericDirectivesModule } from '@ddt-web/generic-utils';
import { StoreModule } from '@ngrx/store';

import { AutoDismissDirective } from './directives/auto-dismiss.directive';
import { NotificationsIfDirective } from './directives/notifications-if-directive';
import { NotificationsComponent } from './notifications/notifications.component';
import { reducer } from './state/notifications.reducer';

@NgModule({
	imports: [
		CommonModule,
		StoreModule.forFeature('notifications', reducer),
		SharedModule,
		AnimationsModule,
		RouterModule,
		GenericDirectivesModule
	],
	declarations: [NotificationsComponent, AutoDismissDirective, NotificationsIfDirective],
	exports: [NotificationsComponent, NotificationsIfDirective]
})
export class NotificationsModule { }
